export function filter() {
  let filters = document.getElementsByClassName("filters-form");

  [...filters].forEach((filtrForm) => {
    const selects = filtrForm.getElementsByClassName("filters-form__select");

    [...selects].forEach((select) => {
      select.addEventListener("change", (event) => {
        filtrForm.submit();
      });
    });
  });
}
